export default __webpack_public_path__ + "static/media/semiquaver.8356928f.png";